var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "modal-body d-flex justify-content-center align-items-center min-vh-25",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column align-items-center text-center p-4 bg-white rounded",
          staticStyle: {
            "min-width": "280px",
            width: "100%",
            "max-width": "400px",
          },
        },
        [
          _c("i", {
            staticClass: "fas fa-spinner fa-spin fa-3x text-primary mb-4",
          }),
          _vm._v(" "),
          _c("ParseProgress"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }